export default {"src":"/_next/static/media/appleDark.7cc9f8ab.svg","height":69,"width":198,"blurWidth":0,"blurHeight":0};